/* tslint:disable */
/* eslint-disable */
/**
 * seller
 * アグリノート米市場 Seller API
 *
 * The version of the OpenAPI document: 0.0.1
 * Contact: mazhulin.d@water-cell.jp
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime'
/**
 * 生産者（Seller）
 * @export
 * @interface ProducerCreateSeller
 */
export interface ProducerCreateSeller {
  /**
   * 自身での検査可否
   * @type {boolean}
   * @memberof ProducerCreateSeller
   */
  canSelfInspect: boolean
  /**
   * 都道府県ID
   * @type {number}
   * @memberof ProducerCreateSeller
   */
  prefectureId: number
  /**
   * 自動ログイン用のJWT
   * @type {string}
   * @memberof ProducerCreateSeller
   */
  jwt: string
  /**
   * 対象の利用規約バージョンの識別子
   *
   * 最新のバージョンと異なる場合、409エラーが返ってくる
   * @type {string}
   * @memberof ProducerCreateSeller
   */
  tosVersion: string
  /**
   * 利用規約同意フラグ
   *
   * デフォルトではfalse
   *
   * ユーザの操作によりtrueに切り替える
   *
   * falseの場合、403エラーが返ってくる
   * @type {boolean}
   * @memberof ProducerCreateSeller
   */
  tosAgreementFlag: boolean
}

export function ProducerCreateSellerFromJSON(json: any): ProducerCreateSeller {
  return ProducerCreateSellerFromJSONTyped(json, false)
}

export function ProducerCreateSellerFromJSONTyped(json: any, ignoreDiscriminator: boolean): ProducerCreateSeller {
  if (json === undefined || json === null) {
    return json
  }
  return {
    canSelfInspect: json['can_self_inspect'],
    prefectureId: json['prefecture_id'],
    jwt: json['jwt'],
    tosVersion: json['tos_version'],
    tosAgreementFlag: json['tos_agreement_flag'],
  }
}

export function ProducerCreateSellerToJSON(value?: ProducerCreateSeller | null): any {
  if (value === undefined) {
    return undefined
  }
  if (value === null) {
    return null
  }
  return {
    can_self_inspect: value.canSelfInspect,
    prefecture_id: value.prefectureId,
    jwt: value.jwt,
    tos_version: value.tosVersion,
    tos_agreement_flag: value.tosAgreementFlag,
  }
}
